/**
 * How detections are drawn on the video, chosen by the viewer and kept for next time: the colour of a one-kind
 * video's marks (a video counting several kinds keeps a colour per kind). Green is the default; the others stay
 * readable on snow, grass, water and sky, and none is the red of a proposed removal or the white of a picked mark.
 */
export const DETECTION_COLORS = [
	{ name: 'green', rgb: '32, 172, 107' },
	{ name: 'yellow', rgb: '255, 214, 10' },
	{ name: 'cyan', rgb: '34, 211, 238' },
	{ name: 'magenta', rgb: '236, 72, 153' },
	{ name: 'orange', rgb: '251, 146, 60' },
];

const KEY = 'videoDetectionColor';

export const colorNamed = name =>
	DETECTION_COLORS.find(c => c.name === name) || DETECTION_COLORS[0];

/** The colour after `name`, round the list. */
export const nextColor = name => {
	const i = DETECTION_COLORS.findIndex(c => c.name === name);
	return DETECTION_COLORS[(i + 1) % DETECTION_COLORS.length];
};

export const savedColor = () => {
	try {
		return colorNamed(localStorage.getItem(KEY));
	} catch {
		return DETECTION_COLORS[0];
	}
};

export const saveColor = name => {
	try {
		localStorage.setItem(KEY, name);
	} catch {
		// a private window: the choice lasts this visit only
	}
};

/**
 * A box's corners as one path: an arm on each corner, a quarter of the shorter side (at least minArm, at most maxArm),
 * so a mark frames the object without hiding it.
 */
export const cornerPath = (path, x1, y1, w, h, minArm, maxArm) => {
	const a = Math.max(minArm, Math.min(maxArm, 0.25 * Math.min(w, h)));
	const x2 = x1 + w;
	const y2 = y1 + h;
	path.moveTo(x1, y1 + a);
	path.lineTo(x1, y1);
	path.lineTo(x1 + a, y1);
	path.moveTo(x2 - a, y1);
	path.lineTo(x2, y1);
	path.lineTo(x2, y1 + a);
	path.moveTo(x2, y2 - a);
	path.lineTo(x2, y2);
	path.lineTo(x2 - a, y2);
	path.moveTo(x1 + a, y2);
	path.lineTo(x1, y2);
	path.lineTo(x1, y2 - a);
	return path;
};
